import React from "react";

export type MClassSymbol = "l_avg" | "u_o" | "u_l" | "f_ti" | "r_ei";
export type CPClassSymbol = "e_avg" | "e_min" | "u_oe";

export const M_CLASS_SYMBOLS: { symbol: MClassSymbol; htmlSymbol: React.ReactNode }[] = [
  { symbol: "l_avg", htmlSymbol: <strong>L̄m</strong> },
  {
    symbol: "u_o",
    htmlSymbol: (
      <strong>
        U<sub>o</sub>
      </strong>
    ),
  },
  {
    symbol: "u_l",
    htmlSymbol: (
      <strong>
        U<sub>l</sub>
      </strong>
    ),
  },
  {
    symbol: "f_ti",
    htmlSymbol: (
      <strong>
        f<sub>TI</sub>
      </strong>
    ),
  },
  {
    symbol: "r_ei",
    htmlSymbol: (
      <strong>
        R<sub>EI</sub>
      </strong>
    ),
  },
];

// C and P share the same photometric symbols; kept as separate exports for semantic clarity.
const CP_CLASS_SYMBOLS: { symbol: CPClassSymbol; htmlSymbol: React.ReactNode }[] = [
  { symbol: "e_avg", htmlSymbol: <strong>Ēm</strong> },
  {
    symbol: "e_min",
    htmlSymbol: (
      <strong>
        E<sub>min</sub>
      </strong>
    ),
  },
  {
    symbol: "u_oe",
    htmlSymbol: (
      <strong>
        U<sub>o</sub> (E)
      </strong>
    ),
  },
];

export const C_CLASS_SYMBOLS = CP_CLASS_SYMBOLS;
export const P_CLASS_SYMBOLS = CP_CLASS_SYMBOLS;
